import type { MaintenancePlan } from '@logistech/ui-shared';

// Alignés sur les enums MaintenanceType / WorkOrderStatus (prisma/schema.prisma)
export const PLAN_TYPE_LABELS: Record<MaintenancePlan['type'], string> = {
  KM: 'Kilométrage',
  HOURS: 'Heures moteur',
  DATE: 'Calendaire',
  HYBRID: 'Mixte',
};

export const fmtDay = (d: string | null) => (d ? new Date(d).toLocaleDateString('fr-FR') : null);
export const fmtKm = (km: number | null) => (km != null ? `${km.toLocaleString('fr-FR')} km` : null);

/** Échéance dépassée (date passée ou kilométrage atteint) ou proche (15 jours / 1 000 km). */
export const dueState = (p: MaintenancePlan): 'overdue' | 'soon' | 'ok' => {
  const odo = p.vehicle?.odometerKm ?? 0;
  const daysLeft = p.nextDate ? (new Date(p.nextDate).getTime() - Date.now()) / 86_400_000 : Infinity;
  const kmLeft = p.nextKm != null ? p.nextKm - odo : Infinity;
  if (daysLeft <= 0 || kmLeft <= 0) return 'overdue';
  if (daysLeft <= 15 || kmLeft <= 1000) return 'soon';
  return 'ok';
};

export const DUE_BADGE = {
  overdue: { label: 'En retard', variant: 'destructive' },
  soon: { label: 'Bientôt', variant: 'warning' },
  ok: { label: 'À jour', variant: 'success' },
} as const;

export const nextDue = (p: MaintenancePlan): string =>
  [fmtDay(p.nextDate), fmtKm(p.nextKm), p.nextHours != null ? `${p.nextHours} h` : null]
    .filter(Boolean)
    .join(' · ') || '—';
